import { katTranslator } from '../../shared/i18n';
import strings from './strings';

export default katTranslator(strings);
